import Model from 'core/model/Model';

export default class AddOn extends Model {
  get urlRoot() {
    return `/api/ui/sudo/addons/${this.get('company_id')}`;
  }
}
